export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apartment.06129fb.svg";